// A language's flag, round (the picker and the button that opens it). Only the site's languages'
// flags, square, so the shell carries 13 file names rather than flag-icons' whole set (Flag.tsx).
import { LOCALE_INFO, type Locale } from '../i18n';

const FILES = import.meta.glob('./{gb,de,es,fr,tr,dk,kr,jp,it,se,pl,br,nl}.svg', {
  base: '../../node_modules/flag-icons/flags/1x1/',
  query: '?url',
  import: 'default',
  eager: true,
}) as Record<string, string>;

export function LocaleFlag({
  locale,
  className = 'h-5 w-5',
}: {
  locale: Locale;
  className?: string;
}) {
  const src = FILES[`./${LOCALE_INFO[locale].flag}.svg`];
  return src ? (
    <img
      src={src}
      alt=""
      draggable={false}
      decoding="async"
      className={`shrink-0 rounded-full object-cover shadow-[0_0_0_1px_rgba(17,17,16,0.12)] ${className}`}
    />
  ) : null;
}
